module.exports = __webpack_public_path__ + "static/media/icon-firmes.14aa8e11.svg";